/**
 * Chain ID Mapper
 * Maps blockchain names to chain IDs for the smart contract API
 */

const CHAIN_NAME_TO_ID = {
  'Ethereum': 1,
  'Abstract': 2741,
  'ApeChain': 33139,
  'Arbitrum Nova': 42170,
  'Arbitrum One': 42161,
  'Arbitrum': 42161, // Alias for Arbitrum One
  'Avalanche C-Chain': 43114,
  'Avalanche C': 43114, // Alias
  'Base': 8453,
  'Berachain': 80094,
  'BitTorrent Chain': 199,
  'Blast': 81457,
  'BNB Smart Chain': 56,
  'BSC': 56, // Alias
  'Celo': 42220,
  'Fraxtal': 252,
  'Gnosis': 100,
  'HyperEVM': 999,
  'Katana': 747474,
  'Linea': 59144,
  'Mantle': 5000,
  'Monad': 143,
  'Moonbeam': 1284,
  'Moonriver': 1285,
  'OP': 10,
  'Optimism': 10, // Alias
  'opBNB': 204,
  'Polygon': 137,
  'Scroll': 534352,
  'Sei': 1329,
  'Sonic': 146,
  'Stable': 988,
  'Swellchain': 1923,
  'Taiko': 167000,
  'Unichain': 130,
  'World': 480,
  'XDC': 50,
  'zkSync': 324,
  'Soneium': 1946
};

/**
 * Get chain ID from blockchain name
 * @param {string} blockchainName - Blockchain name
 * @returns {number|null} Chain ID or null if not found
 */
export const getChainId = (blockchainName) => {
  return CHAIN_NAME_TO_ID[blockchainName] || null;
};

/**
 * Get blockchain name from chain ID
 * @param {number} chainId - Chain ID
 * @returns {string|null} Blockchain name or null if not found
 */
export const getBlockchainName = (chainId) => {
  const entry = Object.entries(CHAIN_NAME_TO_ID).find(([_, id]) => id === chainId);
  return entry ? entry[0] : null;
};

/**
 * Get all supported blockchain names
 * @returns {string[]} Array of blockchain names
 */
export const getSupportedBlockchains = () => {
  return Object.keys(CHAIN_NAME_TO_ID);
};

export default {
  getChainId,
  getBlockchainName,
  getSupportedBlockchains,
  CHAIN_NAME_TO_ID
};

